import Collection from '@/stores/abstract/Collection';
import Model from '@/stores/abstract/Model';
import axiosInstance from '@/helpers/axios';
import {generateLog} from '@/helpers/functions';

const URL: string = 'media/folders';

export class Folders extends Model<IMediaItem> implements IMediaItem {

  id!: number | null;
  mediaFolderId!: number;
  updatedAt!: string;
  name!: string;
  path!: string;
  type!: string;
  active!: boolean;
  children!: any[];
  fileName!: string | null;
  folderName!: string | null;

  constructor(attributes: any = {}, parentCollection?: any) {
    super(
      {...{id: null, mediaFolderId: 0, updatedAt: '', name: '', path: '',  filename: '', type: '', active: true, children: [], fileName: null, folderName: null}, ...attributes}, // Default values
      parentCollection,
    );
  }
  urlRoot(): string {
    return URL;
  }
}

export default class FoldersCollection extends Collection<Folders> {

  routeName = 'Folder';
  model(): Constructor<Folders> {
    return Folders;
  }

  url(): string {
    return URL;
  }
  deleteFolders(ids: any) {
    return axiosInstance.delete(`${this.url()}/${ids}`)
      .then((response) => response.data).catch((e) => {
        const log: any = {
          route: this.routeName,
          message: e,
        };
        generateLog(log);
      });
  }
  getFolder(id: number, search: string = '') {
    return axiosInstance.get(`${this.url()}/${id}?search=${search}`)
      .then((response) => response.data).catch((e) => {
        const log: any = {
          route: this.routeName,
          message: e,
        };
        generateLog(log);
      });
  }
  createFolder(n: string, id: string) {
    return axiosInstance.post(`${this.url()}`, {mediaFolderId: Number(id), name: n})
      .then((response) => response.data).catch((e) => {
        const log: any = {
          route: this.routeName,
          message: e,
        };
        generateLog(log);
      });
  }
  editFolder(folder: any) {
    return axiosInstance.put(`${this.url()}/${folder.id}`, folder)
      .then((response) => response.data).catch((e) => {
        const log: any = {
          route: this.routeName,
          message: e,
        };
        generateLog(log);
      });
  }

  moveMediaItems(mediaFolderId: number, folderIds: number[], fileIds: number[]) {
    return axiosInstance.post(`${this.url()}/move`, {mediaFolderId, folderIds, fileIds})
      .then((response) => response.data).catch((e) => {
        const log: any = {
          route: this.routeName,
          message: e,
        };
        generateLog(log);
      });
  }
}
